import React from "react";
import Bnav from "../Booking-Nav/Bnav";
import Babout from "../Booking-About/Babout";
import Footer from "../Footer/Footer";
import Stay from "../booking-Stay/Stay";

function Second() {
  return (
    <div>
      <Bnav />
      <Babout />
      <Stay />
      <Footer />
    </div>
  );
}

export default Second;
